import { render, staticRenderFns } from "./TenderThumbsRating.vue?vue&type=template&id=54d8fa3e"
import script from "./TenderThumbsRating.vue?vue&type=script&lang=js"
export * from "./TenderThumbsRating.vue?vue&type=script&lang=js"
import style0 from "./TenderThumbsRating.vue?vue&type=style&index=0&id=54d8fa3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports